import axiosFunc from "../components/Utilities/axiosFunc";
import axiosFuncExcel from "../components/Utilities/axiosFuncExcel";

export const login = async body => {
  return await axiosFunc("post", "/login", body);
};

export const dashboardApi = async () => {
  return await axiosFunc("get", "/dashboard");
};

export const vipUsersApi = async () => {
  return await axiosFunc("get", "/vip-users");
};

export const getYearSalesApi = async () => {
  return await axiosFunc("get", "/get-last-12-month-sales");
};

export const mostOrderedProductsApi = async () => {
  return await axiosFunc("get", "/most-ordered-products");
};

export const mostVisitedProductsApi = async () => {
  return await axiosFunc("get", "/most-visited-products");
};

export const getPromoCodeApi = async () => {
  return await axiosFunc("get", "/promo-code/list");
};

export const createPromoCodeApi = async body => {
  return await axiosFunc("post", "/promo-code/create-promo-code", body);
};

export const updatePromoCodeApi = async body => {
  return await axiosFunc("patch", "/promo-code/edit-promo-code", body);
};

export const previousAndCurrentOrderApi = async () => {
  return await axiosFunc("get", "/daily-order-from-last-2-months");
};

export const usersApi = async params => {
  return await axiosFunc("get", "/user/search-user-by-keyword", {}, params);
};

export const updateUsersApi = async body => {
  return await axiosFunc("post", "/user/update-user", body);
};

export const usersDetailsApi = async params => {
  return await axiosFunc("get", "/user/user-details", {}, params);
};

export const categoryApi = async params => {
  return await axiosFunc("get", "/category/search-category", {}, params);
};

export const latestPendingReviewApi = async () => {
  return await axiosFunc("get", "/latest-pending-reviews");
};

export const categoryProductApi = async params => {
  return await axiosFunc("get", "/category/category-data", {}, params);
};

export const updateCategoryApi = async body => {
  return await axiosFunc("patch", "/category/update-category", body);
};

export const updateCategoryImageApi = async params => {
  return await axiosFunc("get", "/category/image-upload-url", {}, params);
};

export const addCategoryApi = async body => {
  return await axiosFunc("post", "/category/add-category", body);
};

export const deleteCategoryApi = async params => {
  return await axiosFunc("delete", "/category/delete-category", {}, params);
};

export const productApi = async params => {
  return await axiosFunc("get", "/product/search-product", {}, params);
};

export const addProductApi = async body => {
  return await axiosFunc("post", "/product/add-product", body);
};

export const productDetailApi = async params => {
  return await axiosFunc("get", "/product/product-detail", {}, params);
};

export const productAddImageApi = async body => {
  return await axiosFunc("post", "/product/add-image-to-product", body);
};

export const productUpdateBasicDetailsApi = async body => {
  return await axiosFunc("patch", "/product/edit-product-basic-detail", body);
};

export const productUpdateDimentionsDetailsApi = async body => {
  return await axiosFunc("patch", "/product/edit-product-dimension", body);
};

export const productUpdateReviewApi = async body => {
  return await axiosFunc("patch", "/product/edit-product-review", body);
};

export const productUploadFromExcelApi = async body => {
  return await axiosFuncExcel("post", "/product/upload-products", body);
};

export const getProductExcelApi = async () => {
  return await axiosFunc("get", "/product/list-of-products-from-sheet");
};

export const deleteProductApi = async params => {
  return await axiosFunc("delete", "/product/delete-product", {}, params);
};

export const orderApi = async params => {
  return await axiosFunc("get", "/order/search-order", {}, params);
};

export const updateOrderApi = async body => {
  return await axiosFunc("patch", "/order/update-order", body);
};

export const updateProductDescriptionApi = async body => {
  return await axiosFunc("patch", "/product/edit-product-description", body);
};

export const updateProductInventryApi = async body => {
  return await axiosFunc("patch", "/product/edit-product-inventory", body);
};

export const updateProductCharacteristicApi = async body => {
  return await axiosFunc("patch", "/product/edit-product-characteristic", body);
};

export const updateProductColorApi = async body => {
  return await axiosFunc("patch", "/product/edit-product-colors", body);
};

export const updateProductWarrantyApi = async body => {
  return await axiosFunc("patch", "/product/edit-product-warranty", body);
};

export const updateProductVideoApi = async body => {
  return await axiosFunc("patch", "/product/edit-product-video", body);
};

export const addProductBoughtTogetherApi = async body => {
  return await axiosFunc("post", "/product/add-frequently-bought-product", body);
};

export const deleteProductBoughtTogetherApi = async body => {
  return await axiosFunc("patch", "/product/delete-frequently-bought-product", body);
};

export const enquiryLeadsApi = async params => {
  return await axiosFunc("get", "/enquiry-leads", {}, params);
};
